import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, shallowRef } from "vue";
import DuduAjax from "@/utils/DuduAjax";
import { API_BIS_PROJECT } from "@/configs/Apis";
import { showSuccess } from "@/utils/UI";
import { isEmpty, isEmptyOrWhiteSpace } from "@/utils/Common";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectEditDialog',
  emits: ["saved"],
  setup(__props, { expose, emit }) {



const visible = ref(false);
const form = shallowRef<any>(null);

const postedData = reactive({
  id: "",
  name: "",
  remark: "",
});

const rules = computed(() => ({
  name: [{ required: true, message: "请输入数据库名称", trigger: "blur" }],
}));

const open = (initData: any = null) => {
  Object.assign(postedData, { id: "", name: "", remark: "" });
  if (!isEmpty(initData)) {
    Object.assign(postedData, {
      id: (initData as any).id,
      name: (initData as any).name,
      remark: (initData as any).remark,
    });
  }
  visible.value = true;
};

const save = async () => {
  const isValid = await form.value.validate().catch(() => false);
  if (!isValid) {
    return;
  }
  const postedRequestData: any = { name: postedData.name, remark: postedData.remark };
  if (!isEmptyOrWhiteSpace(postedData.id)) {
    postedRequestData.id = postedData.id;
  }
  if (isEmptyOrWhiteSpace(postedData.id)) {
    await DuduAjax.post(API_BIS_PROJECT, postedRequestData);
  } else {
    await DuduAjax.put(API_BIS_PROJECT, postedRequestData);
  }
  showSuccess("保存成功");
  visible.value = false;
  emit("saved");
};

expose({ open });

return { __sfc: true,emit, visible, form, postedData, rules, open, save }
}

})